'use client';

import { useFormContext } from 'react-hook-form';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import { Textarea, ITextareaProps } from '@/components/ui/Textarea';

type Props = {
  name: string;
  label?: string;
  description?: string;
} & ITextareaProps;

const TextAreaField = ({
  name, label, description, ...inputProps
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && (
            <FormLabel>
              {label} {inputProps.required && '*'}
            </FormLabel>
          )}
          <FormControl>
            <Textarea
              {...inputProps}
              {...field}
              error={!!errors[name]?.message}
              placeholder={
                inputProps.placeholder && inputProps.required && !label
                  ? `${inputProps.placeholder} *`
                  : inputProps.placeholder
              }
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default TextAreaField;
